import {fetch} from "utils/dataAccess";
import {ShipmentStatus} from "../../utils/ShipmentStatus";

export async function list(params = '') {
    const response = await fetch('/shipments?' + params);

    if (!response.ok) throw new Error('Failed to retrieve shipments');

    const data = await response.json();

    return data;
}

export async function wmsShipmentForShipping(inventoryId) {
    const params = `inventoryId=${inventoryId}&status=${ShipmentStatus.READY_TO_BE_SHIPPED}&shipmentContainerType=tipper&pagination=false`
    const response = await fetch('/shipments/getShipmentForWmsShipping?' + params);

    if (!response.ok) throw new Error('Failed to retrieve WMS shipments for shipping');

    const data = await response.json();

    return data;
}
